import { Company } from './models/company';
import { Subject } from 'rxjs/Subject';
import { SecurityOidcService } from './core/services/system/security.oidc.service';

import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Languages } from './_enumerations/languages';
// import { TranslateLoader } from '@ngx-translate/core';
// import { APP_CONFIGS } from './_configs/appconfigs';
// import { ThemeComponent } from './core/components/system/theme/theme.component';
import { TranslateService } from '@ngx-translate/core';
import { AppContextService } from './services/sji.appcontext.service';

@Component({
  selector: 'app-root',
  templateUrl: './sjiapp.component.html',
  styleUrls: ['./themes/OneUI/all.scss', './sjiapp.component.scss', '../assets/scss/font-awesome.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SJIAppComponent implements OnInit {
  loaded = false;
  loggedIn = false;

  // title = 'Dapasoft Angular 5 template';
  // enableDynamicTheme = APP_CONFIGS.enableDynamicTheme;
  // tslint:disable-next-line:max-line-length
  constructor(private translateService: TranslateService,
    private securityService: SecurityOidcService,
    private appContextService: AppContextService) {
      // Only call one timee init here.
    //   const self = this;
    //   this.securityService.init(function(u) {
    //     console.log('current user:');
    //     console.log(u);
    //       self.appContextService.init().subscribe((response: any) => {
    //         if ( location.href.indexOf('auth-callback') > 0 ) {
    //             // callback page, we did nothing
    //             self.loaded = true;
    //         } else {
    //            if (self.securityService.isLoggedIn() === false) {
    //               self.securityService.startAuthentication();
    //            } else {
    //              self.loggedIn = true;
    //              self.loaded = true;
    //            }
    //         }
    //   });
    // });
    //   // this language will be used as a fallback when a translation isn't found in the current language
    //   this.translateService.addLangs([Languages.English_US, Languages.French_CA, Languages.Chinese_CHS]);
    //   // this.translateService.setDefaultLang(Languages.English_US);
    //   const language = this.securityService.getUserLanguage();
    //   this.translateService.getTranslation(language);
    //   this.translateService.use(language);
  }// End of construtor.

    /**
     * this reason calling ngOnInit here is
     * we cannot declare a class constructor as async.
     * As a workaround we could take advantage of Angular’s lifecycle methods
     * and move our initialisation code to ngOnInit, marking that method as async.
     *
     */
    async ngOnInit() {
      console.log('start call sji appComponent async ngOnInit');
      //
      // Call appContextService.init first.
      // Note: Only call one time appContextservice.init here.
      //
      await this.appContextService.initDomain();
      const logonUser = await this.securityService.init();
      console.log('securitySevice.init completed. Logon User: ' + JSON.stringify(logonUser));
      this.loggedIn = this.securityService.isLoggedIn();
      console.log('sji appcomponent loggedIn = ' + this.loggedIn);
      //
      // Note: Admin Portal no need to call initContext().
      // Disabled.
      // await this.appContextService.initContext();
      //
      
      if ( location.href.indexOf('auth-callback') > 0 || location.href.indexOf('silent-refresh') > 0 ) {
        // callback page, we did nothing
        this.loaded = true;
      } else {
        if (!this.loggedIn) {
            // console.log('before call startAuthentication');
            // User has to login first.
            await this.securityService.login();
        } else {
          this.loaded = true;
        }
      }

      // this language will be used as a fallback when a translation isn't found in the current language
      this.translateService.addLangs([Languages.English_US, Languages.French_CA, Languages.Chinese_CHS]);
      // this.translateService.setDefaultLang(Languages.English_US);
      const language = this.securityService.getUserLanguage();
      this.translateService.getTranslation(language);
      this.translateService.use(language);
    }
}
